/**
 * Keepsy Produktseite: Bausteine unter dem Konfigurator (Inspiration, Schluss-CTA).
 * Prototyp: konfigurator.html, Shop: sections/product-inspiration.liquid und product-cta.liquid
 * (im Theme flach als page-product-extras.js).
 *
 * Links mit data-pdp-design ("So eine Hülle gestalten", "Jetzt gestalten") fuehren sanft nach oben
 * in den Konfigurator: zum Upload, wenn er gerade zu sehen ist (Schritt 2, Foto-Weg), sonst zur
 * Ueberschrift des aktiven Schritts (zum Beispiel "Welches Handy bekommt die Hülle?").
 * Der Fokus landet dort, damit Tastatur und Screenreader mitkommen. Ohne JS springt der Link
 * per Anker (#main) an den Anfang des Konfigurators.
 * Keine Abhaengigkeiten, laeuft einmal pro Seite (Module werden nur einmal ausgefuehrt).
 * @module pages/product-extras
 */

import { mountScrollDots } from '@keepsy/ui-scroll-dots.js'

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

/** Ist das Element sichtbar (nicht in einem versteckten Schritt oder Weg)? */
function visible(el) {
  return Boolean(el && el.getClientRects().length > 0)
}

/**
 * Ziel im Konfigurator: Upload-Button, sonst Titel des aktiven Schritts, sonst der Konfigurator selbst.
 * @returns {{ scrollTo: HTMLElement, focus: HTMLElement, block: ScrollLogicalPosition } | null}
 */
function findTarget() {
  const cfg = document.querySelector('[data-component="configurator"]')
  if (!cfg) return null
  const upload = cfg.querySelector('[data-cfg-upload]')
  const uploadButton = upload && upload.querySelector('[data-action="upload"]')
  if (visible(upload) && visible(uploadButton)) return { scrollTo: upload, focus: uploadButton, block: 'start' }
  const step = [...cfg.querySelectorAll('[data-step-panel]')].find((panel) => !panel.hidden && visible(panel))
  const title = step && step.querySelector('.k-cfg-step__title, h2')
  if (title) return { scrollTo: title, focus: title, block: 'start' }
  return { scrollTo: cfg, focus: cfg, block: 'start' }
}

function goToDesign(event) {
  const link = event.target instanceof Element ? event.target.closest('[data-pdp-design]') : null
  if (!link) return
  const target = findTarget()
  if (!target) return
  event.preventDefault()
  const behavior = reduceMotion.matches ? 'auto' : 'smooth'
  target.scrollTo.scrollIntoView({ behavior, block: target.block })
  if (!target.focus.hasAttribute('tabindex') && !target.focus.matches('a, button, input, select, textarea')) {
    target.focus.setAttribute('tabindex', '-1')
  }
  target.focus.focus({ preventScroll: true })
}

document.addEventListener('click', goToDesign)
mountScrollDots()
